module.exports = __webpack_public_path__ + "static/media/new-magzine-banner.d19df494.png";